module.exports = __webpack_public_path__ + "images/data-camp-comparison.png";